import { Navigate, Route, Routes } from 'react-router-dom';

import {
  TriggeredMessagesList,
  TriggeredMessagesListLayout,
  TriggeredMessagesListScoped,
} from './triggered-messages-list';
import { TriggeredMessageView, TriggeredMessageViewLayout } from './triggered-message-view';
import { TriggeredMessageEdit, TriggeredMessageEditLayout } from './triggered-message-edit';
import { routeCreator } from './triggered-messages.utils';

export const TriggeredMessagesRoutes = () => {
  return (
    <Routes>
      <Route element={<TriggeredMessagesListLayout />}>
        <Route index element={<TriggeredMessagesList />} />
        <Route path={routeCreator.listByScope.path} element={<TriggeredMessagesListScoped />} />
      </Route>

      <Route path={routeCreator.view.path} element={<TriggeredMessageViewLayout />}>
        <Route index element={<TriggeredMessageView />} />
      </Route>

      <Route path={routeCreator.viewScoped.path} element={<TriggeredMessageViewLayout />}>
        <Route index element={<TriggeredMessageView />} />
      </Route>

      <Route path={routeCreator.edit.path} element={<TriggeredMessageEditLayout />}>
        <Route index element={<TriggeredMessageEdit />} />
      </Route>

      <Route path={routeCreator.editScoped.path} element={<TriggeredMessageEditLayout />}>
        <Route index element={<TriggeredMessageEdit />} />
      </Route>

      <Route path='*' element={<Navigate to={routeCreator.base.to()} replace />} />
    </Routes>
  );
};
